<script setup>
</script>

<template>
    <div class="border rounded-lg border-gray-400 p-6">
        <slot></slot>
    </div>
</template>